export function GreekKeyDivider({ className = "" }) {
  return (
    <div className={`w-full overflow-hidden h-4 sm:h-5 ${className}`} aria-hidden="true" data-testid="greek-key-divider">
      <svg viewBox="0 0 80 16" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <defs>
          <pattern id="greekKeyPattern" width="20" height="16" patternUnits="userSpaceOnUse">
            <path d="M0 2 H10 V8 H4 V12 H16 V4 H20" fill="none" stroke="#9a8968" strokeWidth="1.6" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#greekKeyPattern)" />
      </svg>
    </div>
  );
}
